'use strict';

import AOS from 'aos';

import startTurboLinks from './scripts/podcasts/startTurboLinks';
import utils from './scripts/lib/utils';
import headerScrolling from './scripts/headerScrolling';
import toggleMenu from './scripts/toggleMenu';
import loadSlider from './scripts/podcasts/loadSlider';
import resizeGridCard from './scripts/podcasts/resizeGridCard';
import scrollCalendar from './scripts/podcasts/scrollCalendar';
import podcastPlayer from './scripts/podcasts/podcastPlayer';
import scrollToSpecial from './scripts/podcasts/scrollToSpecial';
import navPodcast from './scripts/podcasts/navContentPodcasts';
import replaceSvg from './scripts/podcasts/replaceSvg';
import specialImage from './scripts/podcasts/podcastSpecialPlaylist';
import loadUrlSpecial from './scripts/podcasts/loadUrlSpecial';
import shareSocialMidia from './scripts/shareSocialMidia';
import companyParallax from './scripts/companyParallax';
import mainHomePodcastToggle from './scripts/mainHomePodcastToggle';
import loadSearchPreview from './scripts/loadSearchPreview';

console.log('start podcast application');
AOS.init();

startTurboLinks();
utils();
loadSlider();
toggleMenu();
companyParallax();
resizeGridCard();
scrollToSpecial();
podcastPlayer();
headerScrolling();
navPodcast();
loadSearchPreview();
replaceSvg();
mainHomePodcastToggle();
specialImage(); 
loadUrlSpecial();
shareSocialMidia();
scrollCalendar();

